module.exports = __webpack_public_path__ + "static/media/logo-telegram-black.ae621c28.svg";